de:
  registrant: Melder
  backoffice: Backoffice
fr:
  backoffice: Secrétariat
  registrant: Déclarant
it:
  backoffice: Backoffice
  registrant: Notificante
